import { render } from "./AuthorityManagement.vue?vue&type=template&id=5c4a0940&scoped=true&ts=true"
import script from "./AuthorityManagement.vue?vue&type=script&lang=ts"
export * from "./AuthorityManagement.vue?vue&type=script&lang=ts"

import "./AuthorityManagement.vue?vue&type=style&index=0&id=5c4a0940&scoped=true&lang=css"
import "./AuthorityManagement.vue?vue&type=style&index=1&id=5c4a0940&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4a0940"]])

export default __exports__